@if (originalData?.length) {
  <div class="w-full">
    <mat-form-field appearance="outline" class="w-full mt-1">
      @if (to?.label) {
        <mat-label>
          {{to?.label}}
        </mat-label>
      }
      <mat-select [formControl]="$any(formControl)" [placeholder]="to.label" #singleSelect [multiple]="to.multiple">
        <mat-option>
          <ngx-mat-select-search [formControl]="formFilterControl" ngModel
            (ngModelChange)="filterMyOptions($event)" [placeholderLabel]="'Find ' + to.label + '...'"
            i18n-placeholderLabel [noEntriesFoundLabel]="'no matching '+ to.label + ' found'"
          i18n-noEntriesFoundLabel></ngx-mat-select-search>
        </mat-option>
        @for (item of filteredData | async; track item) {
          <mat-option [value]="item?.value">
            {{item?.label}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
}
